import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { QUERY } from '~/utils/media';
import { Grid } from '~/components/grid';
import { Carousel } from '~/components/carousel';
import { Subheadline, SmallHeadline } from "~/components/typography";
import { ProductItem } from './../product-item';
import {
  ProductCarouselWrapper,
  ProductCarouselTitle,
} from './product-carousel.style';

export const ProductCarousel = ({
  title,
  ctaPath,
  products,
}) => {
  const options = {
    centered: false,
    initial: 0,
    loop: false,
    mode: "snap",
    slidesPerView: 3,
    spacing: 16,
    breakpoints: {
      [QUERY.XLARGE]: {
        slidesPerView: 4,
      },
      [QUERY.MEDIUM]: {
        slidesPerView: 2,
      },
    },
  };

  const controls = {
    offset: '-15%',
  };

  const items = useMemo(() => {
    return products.map(product =>
      <ProductItem {...product} />
    );
  }, [products]);

  if (!items.length) {
    return null;
  }

  return (
    <ProductCarouselWrapper>
      {title && (
        <ProductCarouselTitle>
          <Subheadline color="accentTwo">{title}</Subheadline>
          {ctaPath && (
            <SmallHeadline>
              <Link to={ctaPath}>
                View all
              </Link>
            </SmallHeadline>
          )}
        </ProductCarouselTitle>
      )}
      <Grid>
        <Carousel
          {...{
            items,
            options,
            controls,
          }}
        />
      </Grid>
    </ProductCarouselWrapper>
  )
};
ProductCarousel.defaultProps = {
  products: [],
};
ProductCarousel.propTypes = {
  title: PropTypes.string,
  products: PropTypes.array,
};
